import { useState } from 'react'

import { Button, IllustrationType } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectEmployeesAssignmentEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import EmployeeAssignmentSelector from 'modules/project_management/components/EmployeeAssignmentSelector'

export interface AssignEmployeesSingeProjectModalProps {
  onClose: () => void
  onSubmit: (
    oldEmployeesAssignment: string,
    newEmployeesAssignment: string,
    employeeSelection: EmployeeSelectorV2MultiSelectState
  ) => Promise<void>
  loading: boolean
  title: string
  description: string
  iconName: IllustrationType
  initialAssignedEmployeeIds: string[]
  submitButton: string
  employeesAssignment: ProjectManagementProjectEmployeesAssignmentEnum
}

const AssignEmployeesSingleProjectModal = ({
  onClose,
  onSubmit,
  loading,
  title,
  description,
  iconName,
  initialAssignedEmployeeIds,
  submitButton,
  employeesAssignment,
}: AssignEmployeesSingeProjectModalProps) => {
  const [employeeSelection, setEmployeeSelection] = useState<EmployeeSelectorV2MultiSelectState>({
    type: 'manual',
    ids: employeesAssignment === 'manual' ? initialAssignedEmployeeIds : [],
  })

  const [assignmentSelection, setAssignmentSelection] =
    useState<ProjectManagementProjectEmployeesAssignmentEnum>(employeesAssignment)

  const isManualSelected = assignmentSelection === 'manual'

  const toggleAssignmentSelection = (value: ProjectManagementProjectEmployeesAssignmentEnum) => {
    setAssignmentSelection(value)
  }

  const onSelectEmployees = (newSelection: EmployeeSelectorV2MultiSelectState) => {
    setEmployeeSelection(newSelection)
  }

  const submitModal = () => {
    onSubmit(employeesAssignment, assignmentSelection, employeeSelection)
  }

  const disableSubmitButton = () => {
    const hasNoEmployeesSelected =
      employeeSelection.type === 'manual' && !employeeSelection.ids.length
    return (isManualSelected && hasNoEmployeesSelected) || loading
  }

  return (
    <Modal
      illustration={iconName}
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={submitModal}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disableSubmitButton()} submit>
            {submitButton}
          </Button>
        </>
      }
    >
      <EmployeeAssignmentSelector
        isManualSelected={isManualSelected}
        onSelectEmployees={onSelectEmployees}
        initialEmployeeIds={employeesAssignment === 'manual' ? initialAssignedEmployeeIds : []}
        toggleAssignmentSelection={toggleAssignmentSelection}
      />
    </Modal>
  )
}

export default observer(AssignEmployeesSingleProjectModal)
